import { Icon, MenuItem } from '@chakra-ui/react';
import React from 'react'
import { SuccesToastWithText } from '../../../Shared/ToastMessage/SuccessToast';
import { DeleteBtnWithConfirmation } from '../../../Shared/DeleteBtnWithConfirmation/DeleteBtnWithConfirmation';
import { FiTrash } from 'react-icons/fi';
import { DataContext } from '../../../../state/DataContext/DataContext';

interface IDeleteJobBtn {
    afterDeleteFn?: any,
    TenantID: string,
    JobID: string,
    renderBtn?: any,
}

export const DeleteJobBtn = (props: IDeleteJobBtn) => {
    const { data, actions } = React.useContext(DataContext);

    const deleteJob = (callback) => {
        actions.Job.DeleteJob(props.TenantID, props.JobID).then(() => {
            SuccesToastWithText("Job deleted succesfully!")
            callback()
        })
        if (props.afterDeleteFn) {
            props.afterDeleteFn();
        }
    }
    return (
        <DeleteBtnWithConfirmation
            deleteFn={deleteJob}
            renderBtn={() => {
                return <MenuItem>
                    <Icon as={FiTrash} color="red.500" mr="1" mb="0" /> Delete
                </MenuItem>
            }}
            onClose={props.afterDeleteFn}

        />
    )
}
